import { useState, useEffect } from "react";

function AcceptCookies() {
    const
        [ isHidden, setIsHidden ] = useState<boolean>(false),

        gtag = (...args: any[]) => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(...args);
        },

        isLocalStorageAvailable = () => {
            try {
                const testKey = "__testKey";
                localStorage.setItem(testKey, testKey);
                localStorage.removeItem(testKey);
                return true;
            } catch (e) {
                return false;
            }
        },

        provideConsent = () => {
            if (typeof window !== "undefined" && isLocalStorageAvailable()) {

                const newConsent = {
                    'analytics_storage': 'granted'
                };

                // Send the consent data to GTM
                gtag('consent', 'update', newConsent);

                // Store the consent data in a cookie
                localStorage.setItem("consentMode", JSON.stringify(newConsent));
            }

            window.location.reload();
        };

    useEffect(() => {
        if (typeof window !== "undefined" && isLocalStorageAvailable()) {
            // Retrieve the item from localStorage
            const consentAlreadyProvided = localStorage.getItem('consentMode') !== null;

            // Check if the item exists and is not null
            if (consentAlreadyProvided) {
                setIsHidden(true);
            }
        }
    }, []);

    return (
        <div className={ `popup--accept-cookies ${isHidden ? "is-hidden" : "is-visible"}` }>
            <div className="CookieConsent">
                <span>
                    This website uses cookies to enhance the user experience.
                </span>

                {/** Updates Consent Mode to allow Google Tag Manager **/}
                {/** To start tracking data. **/}
                <button onClick={ () => provideConsent() }>
                    I understand
                </button>
            </div>
        </div>
    );
}

export default AcceptCookies;
